<template>
  <div class="captcha" v-if="show">
    <div class="mask"></div>
    <div class="main">
      <div class="close" @click="close"><i></i></div>
      <div class="title">{{$t('Captcha.title')}}</div>
      <div class="num"><span>{{$t('Captcha.desc1')}}</span><i>{{account}}</i></div>
      <div class="alpha-wrap">
        <div class="alpha">
          <div v-for="(item, index) in letterArray" :key="index" :class="{active: item.active}">{{item.value}}</div>
        </div>
        <input class="input" type="number" v-model="letters" @blur="blur" @focus="focus">
      </div>
      <div class="action">
        <a v-if="countdown==0" @click="resend">{{$t('Captcha.desc2')}}</a>
        <a v-else>
          <template v-if="lang=='zh'">{{countdown}}s后重新发送</template>
          <template v-if="lang=='en'">Resend {{countdown}}s later</template>
        </a>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import { setTitle } from 'components/mixin/title'
import { mapGetters } from 'vuex'
export default {
  props: {
    account: {
      type: String
    },
    countdown: {
      type: Number,
      default: 60
    }
  },
  data() {
    return {
      langKey: this.$route.name,
      letterArray: [],
      letters: '',
      show: false
    }
  },
  computed: {
    ...mapGetters(['lang'])
  },
  created() {
    for (let i = 0; i < 4; i++) {
      let item = {
        value: '',
        active: false
      }
      this.letterArray[i] = item
    }
  },
  methods: {
    blur() {
      this.letterArray.forEach((item, i) => {
        item.active = false
        item.value = this.letters[i]
      })
      this.$forceUpdate()
    },
    focus() {
      if (!this.letters) {
        this.letterArray[0].active = true
      } else {
        this.letterArray[this.letters.length - 1].active = true
      }
      this.$forceUpdate()
    },
    open() {
      this.show = true
    },
    close() {
      this.show = false
    },
    resend() {
      this.$emit('resend')
    }
  },
  mixins: [setTitle],
  watch: {
    letters(nv) {
      if (nv.length >= 4) {
        this.letters = this.letters.substring(0, 4)
      }
      this.letterArray.forEach((item, i) => {
        item.active = false
        item.value = this.letters[i]
      })
      if (this.letters.length) {
        this.letterArray[this.letters.length - 1].active = true
        this.letterArray[this.letters.length - 1].value = this.letters.substring(this.letters.length - 1)
      } else {
        this.letterArray[0].active = true
        this.letterArray[0].value = ''
      }
      this.$emit('input', this.letters)
      this.$forceUpdate()
    }
  }
}
</script>
<style scoped lang="scss">
  @import "css/def";
  .captcha{
    .mask{
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background-color: rgba(0, 0, 0, .5);
      z-index: 99;
    }
    .main{
      position: fixed;
      width: size(600);
      min-height: size(60);
      background-color: #fff;
      top: 50%;
      left: 50%;
      -webkit-transform: translate(-50%, -50%);
      -moz-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      -o-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      z-index: 100;
      -webkit-border-radius: size(10);
      -moz-border-radius: size(10);
      border-radius: size(10);
      padding: size(40) size(66);
      font-size: size(26);
      color: #333;
      text-align: center;
      .close{
        position: absolute;
        right: size(-22);
        top: size(-22);
        i{
          display: inline-block;
          width: size(48);
          height: size(48);
          -webkit-background-size: 100% 100%;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          background-image: url('~image/icon/del.png');
        }
      }
      .title{
        font-size: size(36);
        font-weight: 600;
      }
      .num{
        margin-top: size(26);
        span{
          color: #999;
        }
        i{
          display: inline-block;
          font-style: normal;
          margin-left: size(20);
        }
      }
      .alpha-wrap{
        position: relative;
        margin-top: size(50);
        .alpha{
          position: relative;
          z-index: 1;
          width: 100%;
          @include flex();
          justify-content: space-between;
          >div{
            width: size(110);
            height: size(110);
            background-color: #f1f1f1;
            @include flex();
            font-size: size(48);
            position: relative;
            &.active::after{
              content:'';
              display: block;
              width: 1px;
              height: size(40);
              animation: blink 1s infinite steps(1, start);
            }
          }
        }
        .input{
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: transparent;
          z-index: 2;
          color: transparent;
          opacity: 0;
        }
      }
      .action{
        font-size: size(24);
        margin-top: size(45);
        a{
          color: #0B83FC;
          font-size: size(24);
        }
      }
    }
  }
  @keyframes blink {
    0% {
      background-color: transparent;
    }
    50% {
      background-color: #108EE9;
    }
    100% {
      background-color: transparent;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/captcha.vue